import styled from 'styled-components';
import { Collapse } from 'antd';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
  gap: 12px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: rgb(0 0 0 / 88%);
  min-width: 100px;
`;

export const ConfigurationSection = styled.div`
  padding: 4px;
`;

export const StyledCollapse = styled(Collapse)`
  .gm-ant-collapse-header {
    /* padding: 12px 16px !important; */
    font-size: 14px;
    font-weight: 500;
    color: rgb(0 0 0 / 88%);
    border-bottom: none;
  }

  .gm-ant-collapse-content-box {
    /* padding: 16px !important; */
  }
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  height: 31px;
`;

export const RadioOption = styled.label<{ checked?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: ${(props) => (props.checked ? '#0046ff' : 'rgb(0 0 0 / 88%)')};

  input[type='radio'] {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`;

export const EventsCheckboxContainer = styled.div`
  padding: 16px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  max-height: 300px;
  overflow-y: auto;
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  input[type='checkbox'] {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }

  span {
    font-size: 14px;
    color: rgb(0 0 0 / 88%);
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
`;

export const InfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 12px;
  color: rgb(0 0 0 / 45%);
  cursor: help;
`;
